<template>

    <v-card color="#f5f5f5"
            v-observe-visibility="visibilityChanged">
        <v-toolbar tabs fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add Product</v-toolbar-title>
            <v-toolbar-title v-else>Edit Product - {{selectedItem.reference}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tabs slot="extension"
                    v-model="activeTab"
                    color="secondary"
                    dark
                    slider-color="primary"
                    class="fixSides"
            >
                <v-tab>PRODUCT</v-tab>
                <v-tab :disabled="tabsDisabled">PICTURES</v-tab>
                <v-tab :disabled="tabsDisabled">SUPPLIER OFFERS</v-tab>
             <!--   <v-tab :disabled="tabsDisabled">Google ADS</v-tab>-->
            </v-tabs>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs-items class="fromTop" v-model="activeTab">
            <v-tab-item>

                <v-layout wrap>
                    <v-container grid-list-md>
                        <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
                            <v-hover>
                                <v-card slot-scope="{ hover }"
                                        :class="`elevation-${hover ? 4 : 1}`">
                                    <v-card-title class="headline">{{cardTitle}} Product
                                        <v-spacer/>
                                    </v-card-title>

                                    <v-card-title>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Product</v-subheader>
                                            <v-divider/>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <v-form
                                                    ref="form"
                                                    v-model="valid"
                                                    lazy-validation
                                            >

                                                <v-text-field v-if="!tabsDisabled"
                                                        label="Reference"
                                                        v-model="selectedItem.reference"
                                                        counter
                                                        maxlength="255"
                                                />
                                                <v-text-field v-else
                                                        label="Reference"
                                                        v-model="selectedItem.reference"
                                                        counter
                                                        maxlength="255"
                                                        :disabled="!tabsDisabled"
                                                        :rules="rules"
                                                />

                                            </v-form>
                                        </v-flex>
                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <v-autocomplete
                                                    clearable
                                                    :items="getManufacturers"
                                                    label="Manufacturer"
                                                    v-model="selectedItem.manufacturers_id"
                                                    item-value="id"
                                                    item-text="name"
                                                    :loading="loading"
                                            />
                                        </v-flex>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Product Details</v-subheader>
                                            <v-divider/>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <v-text-field
                                                    suffix="kg"
                                                    label="Net Weight"
                                                    v-model="selectedItem.weight"
                                                    type="number"
                                                    step=".01"
                                                    min="0"
                                            />
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <v-text-field
                                                    label="HSCode"
                                                    v-model="selectedItem.hscode"
                                                    counter
                                                    maxlength="255"
                                            />
                                        </v-flex>

                                        <v-flex xs12 pl-4 pa-2>
                                            <v-textarea
                                                    rows="4"
                                                    label="Product Description"
                                                    v-model="selectedItem.product_description.description"
                                                    counter
                                                    maxlength="500"
                                            />
                                        </v-flex>

                                      <v-flex xs12 pr-3 pl-3>
                                        <v-subheader>Product Details Table</v-subheader>
                                        <v-divider/>
                                      </v-flex>

                                      <v-flex xs12 pl-4 pa-2>
<!--
                                        <TipTapRichtextTableEditor v-if="dialog" v-model="selectedItem.details_table"/>
-->

                                      </v-flex>
                                      <v-flex xs12 pl-4 pa-2>
                                            <v-switch color="secondary" label="Upload to Shop"
                                                      v-model="selectedItem.upload"/>
                                      </v-flex>

                                    </v-card-title>
                                    <v-card-actions>
                                        <v-layout mt-2 pb-3 pr-3>
                                            <v-spacer/>
                                            <v-btn :loading="loading"dark color="secondary" @click.native="saveProductAndGoToNextTab(1)">
                                                Save
                                                <v-icon class="white--text" right>save</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-card-actions>

                                </v-card>
                            </v-hover>
                            <v-layout mt-5 row justify-end>

                            </v-layout>

                        </v-flex>

                    </v-container>
                </v-layout>
            </v-tab-item>
            <v-tab-item>

              <v-layout wrap
                        >
                <v-container grid-list-md>
                  <v-flex xs12 md10 offset-md1 xl6 offset-xl3 >
                    <v-hover>

                      <v-card slot-scope="{ hover }"
                              :class="`elevation-${hover ? 4 : 1}`"
                      >
                        <v-card-title class="headline">Edit Product Pictures
                          <v-spacer/>
                        </v-card-title>

                        <v-card-title>

                          <v-flex xs12 pr-3 pl-3>
                            <v-subheader>Upload/Edit Picture</v-subheader>
                            <v-divider/>
                          </v-flex>

                          <v-flex xs12 pr-3 pl-3>
                            <v-text-field
                              @drop.prevent="dragImage"
                              @dragenter="dragEnter"
                              @dragleave="dragLeave"
                              @dragexit="dragLeave"
                              @dragover.prevent
                              :loading="loadingPicture"
                              label="Select Image"
                              @click='pickFile'
                              :prepend-icon='getPrependIcon'/>
                          </v-flex>

                          <input
                            ref="input"
                            type="file"
                            name="image"
                            accept="image/*"
                            @change="setImage"
                            style="display: none"
                          >
                          <v-flex xs12 pr-3 pl-3>
                            <vue-cropper v-show="imgSrc !== null"
                              ref="cropper"
                              :src="imgSrc"
                              alt="Source Image"
                              :aspect-ratio="4 / 3"
                              :minCropBoxWidth="1920"
                              :cropBoxResizable="false"
                              :toggleDragModeOnDblclick="false"
                              dragMode="move"
                              :modal="true"
                            >
                            </vue-cropper>
                          </v-flex>
                          <v-flex xs12 pr-3 pl-3>
                            <v-layout justify-center row wrap v-show="imgSrc !== null">
                              <v-flex xs1>
                                <v-btn flat icon color="secondary" @click.native="move(-5, 0)">
                                  <v-icon color="secondary">fas fa-angle-left</v-icon>
                                </v-btn>
                              </v-flex>
                              <v-flex xs1>
                                <v-btn flat icon color="secondary" @click.native="move(5, 0)">
                                  <v-icon color="secondary">fas fa-angle-right</v-icon>
                                </v-btn>
                              </v-flex>
                              <v-flex xs1>
                                <v-btn flat icon color="secondary" @click.native="move(0, -5)">
                                  <v-icon color="secondary">fas fa-angle-up</v-icon>
                                </v-btn>
                              </v-flex>
                              <v-flex xs1>
                                <v-btn flat icon color="secondary" @click.native="move(0, 5)">
                                  <v-icon color="secondary">fas fa-angle-down</v-icon>
                                </v-btn>
                              </v-flex>
                              <v-flex xs1>
                                <v-btn flat icon color="secondary" @click.native="zoom(0.02)">
                                  <v-icon color="secondary">fas fa-search-plus</v-icon>
                                </v-btn>
                              </v-flex>
                              <v-flex xs1>
                                <v-btn flat icon color="secondary" @click.native="zoom(-0.02)">
                                  <v-icon color="secondary">fas fa-search-minus</v-icon>
                                </v-btn>
                              </v-flex>
                              <v-flex xs2 mt-1>
                                <v-btn flat small color="secondary" @click.native="cropImage()">
                                  PREVIEW
                                  <v-icon right color="secondary">fas fa-crop</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-layout row justify-center>
                            <v-dialog v-model="cropPreviewDialog" persistent max-width="1024">
                              <v-card>
                                <v-card-title class="headline">Save Cropped Image?</v-card-title>
                                <v-card
                                  flat
                                  class="croppedPreview"
                                  :style="{ backgroundImage: 'url(' + cropImg + ')', width: '100%', height: '768px' , 'background-position': 'center', 'background-repeat': 'no-repeat', 'background-size': '100% auto', }"
                                />
                                <v-card-actions>
                                  <v-spacer/>
                                  <v-btn color="primary darken-1" flat @click.native="cropPreviewDialog = false">Cancel</v-btn>
                                  <v-btn :loading="uploadingImage" color="primary darken-1" flat
                                         @click.native="uploadCroppedImage()">SAVE
                                  </v-btn>

                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-layout>

 <!--                         <v-flex xs12 pr-3 pl-3>
                            <v-textarea label="Cropper Data" v-model="cropperData">
                            </v-textarea>
                          </v-flex>

                          <v-flex xs12 pr-3 pl-3>
                            <v-btn @click="getCropperData">GET CROP DATA</v-btn>
                          </v-flex>-->

                          <v-flex xs12 pr-3 pl-3>
                            <v-subheader>Pictures</v-subheader>
                            <v-divider/>
                          </v-flex>

                          <VueGallery id="productImagesIndex" :images="getSortedImages"
                                      :index="productImageIndex"
                                      @close="productImageIndex = null"/>
                          <div class="carouselor">
                            <v-card
                              class="image"
                              v-for="(image, imageIndex) in getSortedImages"
                              :key="imageIndex"
                              @click="productImageIndex = imageIndex"
                              :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }">
                              <v-card-actions>
                                <p class="title">{{getImageOrder(image)}}</p>
                                <v-spacer/>
                                <v-btn icon flat
                                       @click.stop="openUpdateImageDialog(image)">
                                  <v-icon color="primary">edit</v-icon>
                                </v-btn>
                                <v-btn icon flat
                                       @click.stop="openDeleteImageDialog(image)">
                                  <v-icon color="red">delete</v-icon>
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </div>

                          <v-layout row justify-center>
                            <v-dialog v-model="deleteImageDialog" persistent max-width="350">
                              <v-card>
                                <v-card-title class="headline">Delete Product Picture?</v-card-title>
                                <v-card-text>Product Picture will be deleted!</v-card-text>
                                <v-card-actions>
                                  <v-spacer/>
                                  <v-btn color="primary darken-1" flat @click.native="deleteImageDialog = false">Cancel</v-btn>
                                  <v-btn color="primary darken-1" flat :loading="deletingImage"
                                         @click.native="deleteImage()">OK
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-layout>

                          <v-layout row justify-center>
                            <v-dialog v-model="updateImageDialog" persistent max-width="350">
                              <v-card>
                                <v-card-title class="headline">Update Product Picture Order?</v-card-title>
                                <v-card-text>Product Picture order will be updated!

                                  <v-text-field v-model="selectedUpdateImageOrder" small type="number" min="0" placeholder="Enter Picture Order"/>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer/>
                                  <v-btn color="primary darken-1" flat @click.native="updateImageDialog = false">Cancel</v-btn>
                                  <v-btn color="primary darken-1" flat :loading="deletingImage"
                                         @click.native="editImageOrder()">OK
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-layout>

                        </v-card-title>

                      </v-card>
                    </v-hover>
                    <v-layout mt-5 row justify-end>

                    </v-layout>

                  </v-flex>

                </v-container>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
                <offerPositions/>
            </v-tab-item>
<!--            <v-tab-item>
                <google-adwords></google-adwords>
            </v-tab-item>-->

        </v-tabs-items>

    </v-card>

</template>

<script>
import {
  Settings,
  ManufacturersSettings,
  ProductSettings,
  Documents
} from '../../store/namespace-helper'

import {API_URL} from '../../store/index'

import offerPositions from '../Settings/Products/SupplierOffers/SupplierOffers.vue'
import sendOfferMessage from '../Offers/SendOffer/SendOfferMessage.vue'
import DatetimePicker from '../Shared/DatetimePicker.vue'
import GoogleAdwords from '../ecommerce/googleAds/GoogleAdwords'
import VueCropper from 'vue-cropperjs'
import VueGallery from 'vue-gallery'
import 'cropperjs/dist/cropper.css'
// import TipTapRichtextTableEditor from '../Shared/TipTapRichtextTableEditor'

import _ from 'lodash'

export default {
  components: {
    GoogleAdwords,
    offerPositions,
    sendOfferMessage,
    DatetimePicker,
    VueCropper,
    VueGallery
    //  TipTapRichtextTableEditor
  },
  name: 'add-product',
  props: {
    dontResetSelectedItem: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      activeTab: 0,
      countries: this.$store.getters.countries,
      customContactFilter (item, queryText, itemText) {
        const isMatch = (test, query) => {
          return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
        }
        const query = queryText || ''
        const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
        const rc = isMatch(item.firstname, query) ||
                        isMatch(item.lastname, query) ||
                        isMatch(item.email, query) ||
                        isMatch(displayText, query)
        console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
        return rc
      },
      isVisible: false,
      onDismissed: false,
      sheet: false,
      referenceNotFound: false,
      valid: true,
      rules: [
        v => this.referenceNotFound || 'Reference already existing.'
      ],
      imgSrc: null,
      cropImg: null,
      cropperData: null,
      cropPreviewDialog: false,
      productImageObjects: [],
      productImageIndex: null,
      uploadingImage: false,
      deleteImageDialog: false,
      deleteImageIndex: null,
      deletingImage: false,
      updateImageDialog: false,
      updateImageIndex: null,
      selectedUpdateImageOrder: null,
      loadingPicture: false,
      dragOver: false
    }
  },
  methods: {
    visibilityChanged (isVisible, entry) {
      if (this.isVisible !== isVisible) {
        this.isVisible = isVisible
        if (isVisible) {
          console.log('tab visible, load data')
          this.loadManufacturers()
          this.loadProductImages()
        } else {
          this.supplierUpdated = 0
        }
      }
    },
    closeDialog () {
      this.$store.dispatch(ProductSettings.actions.openCloseDialog)
      if (!this.$props.dontResetSelectedItem) {
        this.$store.dispatch(ProductSettings.actions.setSelectedProduct, null)
      }
      this.productImageObjects = []
      this.productImageIndex = null
      this.activeTab = 0
    },
    searchThrottledReferences: _.debounce(function (val) {
      return this.searchReference(val)
    }, 450),
    loadManufacturers () {
      this.$store.dispatch(ManufacturersSettings.actions.loadAllManufacturers)
    },
    searchReference (val) {
      const searchProduct = {
        search: val
        /*    fulltext: true */
      }
      this.$store.dispatch(ProductSettings.actions.loadAllProducts, searchProduct).then(response => {
        if (response.length > 0) {
          this.referenceNotFound = false
          this.$refs.form.validate()
        } else {
          this.referenceNotFound = true
          this.$refs.form.resetValidation()
        }
      }).catch(function (err) {
        console.log(JSON.stringify(err))
      })
    },
    saveProductAndGoToNextTab (index) {
      if (!this.$refs.form.validate()) {
        return false
      }
      this.$store.dispatch(ProductSettings.actions.saveProduct, this.selectedItem).then(response => {
        /*            this.activeTab = index */
      })
    },
    openBottomSheet (payload) {
      if (payload) {
        this.$store.dispatch('openCloseBottomSheet')
      }
    },
    pickFile () {
      this.$refs.input.click()
    },
    dragEnter () {
      this.dragOver = true
    },
    dragLeave () {
      this.dragOver = false
    },
    dragImage (e) {
      this.dragOver = false
      this.loadingPicture = true
      const file = e.dataTransfer.files[0]
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file')
        this.loadingPicture = false
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
        }
        reader.onloadend = (event) => {
          this.loadingPicture = false
        }
        reader.onerror = (event) => {
          this.loadingPicture = false
        }
        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
        this.loadingPicture = false
      }
    },
    setImage (e) {
      this.loadingPicture = true
      const file = e.target.files[0]
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file')
        this.loadingPicture = false
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
        }
        reader.onloadend = (event) => {
          this.loadingPicture = false
        }
        reader.onerror = (event) => {
          this.loadingPicture = false
        }
        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
        this.loadingPicture = false
      }
    },
    getCropperData () {
      this.cropperData = JSON.stringify(this.$refs.cropper.getData(), null, 4)
    },
    move (offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY)
    },
    zoom (percent) {
      this.$refs.cropper.relativeZoom(percent)
    },
    cropImage () {
      this.cropPreviewDialog = true
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas({
        fillColor: '#fff'
      }).toDataURL('image/jpeg')
    },
    uploadCroppedImage () {
      this.uploadingImage = true
      this.$store.dispatch(ProductSettings.actions.saveProductDocument, {
        product_id: this.selectedItem.id,
        documents: [
          {
            documents_type_id: 6,
            mime_type: 'image/jpeg',
            data: this.cropImg
          }
        ]
      }).then(response => {
        this.$store.dispatch(ProductSettings.actions.setSelectedProduct, response)
        this.uploadingImage = false
        this.cropPreviewDialog = false
        this.$refs.cropper.reset()
        this.imgSrc = null
        this.cropImg = null
        this.loadProductImages()
      }).catch(err => {
        this.uploadingImage = false
        this.cropPreviewDialog = false
        console.log(JSON.stringify(err))
      })
    },
    loadProductImages () {
      this.productImageObjects = []
      if (this.selectedItem.product_document) {
        this.selectedItem.product_document.filter(document => document.document.documents_type_id === 6).forEach((obj, index) => {
          this.$store.dispatch(Documents.actions.getDocumentToken, {
            id: obj.document_id,
            filename: 'productImage_' + obj.product_id + '_' + (index + 1) + '.jpg'
          }).then(response => {
            obj.link = API_URL + '/documentStore/' + response.data.data.token
            this.productImageObjects.push(obj)
          }).catch(reason => {
            console.log('could not get docuement token:' + reason)
          })
        })
      }
    },
    openDeleteImageDialog (index) {
      this.deleteImageIndex = index
      this.deleteImageDialog = true
    },
    openUpdateImageDialog (index) {
      this.updateImageIndex = index
      this.updateImageDialog = true
    },
    deleteImage () {
      this.deletingImage = true
      console.log('imageindex: ' + this.deleteImageIndex)
      let item = this.productImageObjects.find(x => x.link === this.deleteImageIndex)
      if (item) {
        this.$store.dispatch(ProductSettings.actions.deleteProductDocument, {
          id: item.id
        }).then(response => {
          this.$store.dispatch(ProductSettings.actions.setSelectedProduct, response)
          this.deleteImageIndex = null
          this.deletingImage = false
          this.deleteImageDialog = false
          this.loadProductImages()
        }).catch(err => {
          this.deletingImage = false
          console.log(JSON.stringify(err))
        })
      } else {
        this.deletingImage = false
        console.log('could not delete image by index')
      }
    },
    getImageOrder (index) {
      let item = this.productImageObjects.find(x => x.link === index)
      if (item) {
        if (item.order) {
          return item.order
        }
      }
      return '-'
    },
    editImageOrder (index) {
      console.log('imageindex: ' + index)
      this.deletingImage = true
      console.log('imageindex: ' + this.updateImageIndex)
      let item = this.productImageObjects.find(x => x.link === this.updateImageIndex)
      if (item) {
        this.$store.dispatch(ProductSettings.actions.updateProductDocumentOrder, {
          id: item.id,
          order: this.selectedUpdateImageOrder
        }).then(response => {
          this.$store.dispatch(ProductSettings.actions.setSelectedProduct, response)
          this.updateImageDialog = null
          this.deletingImage = false
          this.updateImageDialog = false
          this.selectedUpdateImageOrder = null
          this.loadProductImages()
        }).catch(err => {
          this.deletingImage = false
          console.log(JSON.stringify(err))
        })
      } else {
        this.deletingImage = false
        console.log('could not edit image by index')
      }
    }
  },
  computed: {
    dialog () {
      return this.$store.getters[ProductSettings.getters.getDialogState]
    },
    selectedItem () {
      console.log('selected product: ' + JSON.stringify(this.$store.getters[ProductSettings.getters.getSelectedProduct]))
      return this.$store.getters[ProductSettings.getters.getSelectedProduct]
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    tabsDisabled () {
      return this.$store.getters[ProductSettings.getters.getSelectedProduct].id === 0
    },
    getManufacturers () {
      return this.$store.getters[ManufacturersSettings.getters.getAllManufacturers]
    },
    cardTitle () {
      if (this.selectedItem.id === 0) {
        return 'Add new'
      } else {
        return 'Edit'
      }
    },
    getSortedImages () {
      return this.productImageObjects.sort((a, b) => a.id - b.id).map(a => a.link)
    },
    getPrependIcon () {
      return this.dragOver ? 'fas fa-caret-square-down' : 'fas fa-paperclip'
    }
  },
  watch: {
    'selectedItem.reference':
                function (newVal, oldVal) {
                  if (newVal !== '' && typeof newVal !== 'undefined') {
                    this.searchThrottledReferences(newVal)
                  } else {
                    this.$refs.form.resetValidation()
                  }
                }
  }

}
</script>

<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: var(--secondary-color);
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

    .statusSelecter {
        width: 80px;
    }

  .croppedPreview{
    padding: 32px;
  }

    .carouselor {
      overflow-x: scroll;
      overflow-y: hidden;
      height: auto;
      white-space: nowrap
    }

    .carouselor .image {
      /*  float: left;*/
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      border: 1px solid #ebebeb;
      margin: 8px;
      display: inline-block;
    }

/*
  .dragOverlay:after{
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: var(--primary-color);
    width: 96px;
    height: 96px;
    opacity: 0.4;
    z-index: 1000;
  }
*/

/*  .dragOverlayIcon:before{
    content: '';
    position: absolute;
    margin: auto;
    background-image: url('data:image/svg+xml; utf8,<svg xmlns="http://www.w3.org/2000/svg"  aria-hidden="true" focusable="false" data-prefix="fal" data-icon="upload" class="svg-inline--fa fa-upload fa-w-16" role="img" viewBox="0 0 512 512"><path fill="white" d="M452 432c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20zm-84-20c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20zm144-48v104c0 24.3-19.7 44-44 44H44c-24.3 0-44-19.7-44-44V364c0-24.3 19.7-44 44-44h124v-99.3h-52.7c-35.6 0-53.4-43.1-28.3-68.3L227.7 11.7c15.6-15.6 40.9-15.6 56.6 0L425 152.4c25.2 25.2 7.3 68.3-28.3 68.3H344V320h124c24.3 0 44 19.7 44 44zM200 188.7V376c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8V188.7h84.7c7.1 0 10.7-8.6 5.7-13.7L261.7 34.3c-3.1-3.1-8.2-3.1-11.3 0L109.7 175c-5 5-1.5 13.7 5.7 13.7H200zM480 364c0-6.6-5.4-12-12-12H344v24c0 22.1-17.9 40-40 40h-96c-22.1 0-40-17.9-40-40v-24H44c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12V364z"/></svg>');
    width: 64px;
    height: 64px;
    opacity: 0.8;
    z-index: 1001;
    top: 50%;
    left: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
  }*/

</style>



// WEBPACK FOOTER //
// src/components/Shared/AddProduct.vue